import { EffectsModule } from '@ngrx/effects';
import { AuthService } from './auth.service';
import { CommonImportModule } from './../../shared/common-import.module';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AuthRoutingModule } from './auth-routing.module';
import { StoreModule } from '@ngrx/store';
import * as fromAuth from './state/auth.reducer';
import { AuthEffcts } from './state/auth.effects';
import { SharedModule } from './../../shared/shared.module';
import { CardModule } from 'primeng/card';
import { TimelineModule } from 'primeng/timeline';
import { ImageCropperComponent } from 'ngx-image-cropper';
import { ToastrService } from 'ngx-toastr';
import { OnboardingComponent } from './onboarding/onboarding.component';

// Standalone components (moved from declarations)
import { LoginComponent } from './login/login.component';
import { WelcomePageComponent } from './onboarding/components/welcome-page/welcome-page.component';
import { ClubAdminRegistrationComponent } from './onboarding/components/club-admin-registration/club-admin-registration.component';
import { AdditionalClubDetailsComponent } from './onboarding/components/additional-club-details/additional-club-details.component';
import { OnboardingStepperComponent } from './onboarding/components/onboarding-stepper/onboarding-stepper.component';
import { BrandVisibilityCardComponent } from './onboarding/components/brand-visibility-card/brand-visibility-card.component';
import { ImageCropperDialogComponent } from './onboarding/components/image-cropper-dialog/image-cropper-dialog.component';
import { ReviewAndSubmitComponent } from './onboarding/components/review-and-submit/review-and-submit.component';

// PrimeNG Imports
import { GalleriaModule } from 'primeng/galleria';
import { SelectModule } from 'primeng/select';
import { PasswordModule } from 'primeng/password';
import { InputNumberModule } from 'primeng/inputnumber';
import { PrimeNGImportModule } from 'src/app/shared/primeng-import.module';
import { NavModule } from '../nav/nav.module';
import { RecaptchaModule, RECAPTCHA_SETTINGS, RecaptchaSettings } from 'ng-recaptcha-2';
import { environment } from 'src/environments/environment';
import { SearchBarComponent } from 'src/app/shared/components/competitions/search-bar/search-bar.component';
import { ButtonComponent } from 'src/app/shared/components/button/button.component';

@NgModule({
  declarations: [
    OnboardingComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CommonImportModule,
    AuthRoutingModule,
    StoreModule.forFeature(fromAuth.authFeatureKey, fromAuth.authReducer),
    EffectsModule.forFeature([AuthEffcts]),
    SharedModule,
    ImageCropperComponent,
    CardModule,
    TimelineModule,
    // PrimeNG Modules
    GalleriaModule,
    SelectModule,
    PasswordModule,
    InputNumberModule,
    PrimeNGImportModule,
    NavModule,
    RecaptchaModule,
    SearchBarComponent,
    ButtonComponent,
    // Standalone components
    LoginComponent,
    WelcomePageComponent,
    ClubAdminRegistrationComponent,
    AdditionalClubDetailsComponent,
    OnboardingStepperComponent,
    BrandVisibilityCardComponent,
    ImageCropperDialogComponent,
    ReviewAndSubmitComponent,
  ],
  providers: [
    ToastrService,
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: {
        siteKey: environment.recaptchaSiteKey,
        size: 'invisible',
      } as RecaptchaSettings,
    }
  ]
})
export class AuthModule {
  static forRoot(): ModuleWithProviders<AuthModule> {
    return {
      ngModule: AuthModule,
      providers: []
    }
  }
}
